"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var Element_1 = require("./Element");

var Page_1 = require("./Page");

exports.PageContent = function (_a) {
  var page = _a.page,
      uniqueName = _a.uniqueName;

  if (!page) {
    return null;
  }

  var element = uniqueName && page.elements.find(function (e) {
    return e.uniqueName === uniqueName;
  });

  if (uniqueName && !element) {
    return null;
  }

  var tenant = react_redux_1.useSelector(function (_a) {
    var publicTenants = _a.publicTenants;
    return publicTenants.selected;
  });
  return element ? react_1.default.createElement(Element_1.Element, {
    tenant: tenant,
    element: element,
    root: "Page"
  }) : react_1.default.createElement(Page_1.Page, {
    tenant: tenant,
    page: page
  });
};